export default "__VITE_ASSET__DI1_b7SJ__"